import React from 'react';
type Props = {
  eyebrow?: string;
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  tone?: 'dark' | 'light';
  align?: 'center' | 'left';
};
export function SectionHeading({
  eyebrow,
  title,
  subtitle,
  tone = 'dark',
  align = 'center'
}: Props) {
  const isLight = tone === 'light';
  return <div className={`mx-auto flex max-w-3xl flex-col ${align === 'center' ? 'items-center text-center' : 'items-start text-left'}`} data-id="element-61" data-mp="3jzdnkmhuhqcy">
      {eyebrow ? <p className={`mb-3 text-xs font-extrabold uppercase tracking-[0.18em] ${isLight ? 'text-sky-400' : 'text-sky-600'}`} data-id="element-62" data-mp="gj6rb11reve7">
          {eyebrow}
        </p> : null}
      <h2 className={`font-display text-[26px] font-black leading-[1.12] tracking-tight sm:text-4xl lg:text-[42px] ${isLight ? 'text-white' : 'text-navy-800'}`} data-id="element-63" data-mp="6svcukkg93t2">
        {title}
      </h2>
      {subtitle ? <p className={`mt-4 text-base leading-relaxed sm:text-lg ${isLight ? 'text-navy-100' : 'text-navy-600'}`} data-id="element-64" data-mp="zc0y37p8bh7c">
          {subtitle}
        </p> : null}
    </div>;
}